import { Action } from 'redux';

import { isMaxSiteRoleForServerUserSpaceUpdateAction } from '../actions/MaxSiteRoleForServerUserSpaceActions';


export function maxSiteRoleForServerUsersSpaceReducer(
  previousState: string = 'Any',
  action: Action = null
): string {
  if (isMaxSiteRoleForServerUserSpaceUpdateAction(action) && action?.maxSiteRole) {
    return action.maxSiteRole;
  }
  return previousState;
}

